import React from "react";
import "./ProductDetailCard.css";

const ProductDetailCard = (props) => {
    return (
        <>
            {props.cardType == "1" ? (
                // type 1
                <div className="w-[600px] mb-20" style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
                    <div className="product_name_above_image"></div>
                    <div className="justify-center">
                        <img src={props.image} style={{objectFit:"contain"}} className="rounded-lg w-[450px] h-[300px]" alt="Product Image" />
                        <div className="content_box_type_1 w-[450px]">{props.content}</div>
                    </div>
                </div>
            ) : props.cardType == "2" ? (
                // type 2
                <div className="w-[350px] mx-10 my-5 mb-20">
                    <div className="product_name_above_image">{props.name}</div>

                    <div className="flex justify-center">
                        <img src={props.image} className="rounded-lg w-[350px] h-[250px]" alt="Product Image" style={{objectFit:"contain"}}/>
                    </div>

                    <div className="left-0 w-full mt-[5px]">
                        <div className="flex justify-center">
                            <div
                                className="w-[200px] catalogue_button font-bold"
                                onClick={() => {
                                    window.open(props.content);
                                }}
                            >
                                온라인카다로그
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                // type 3
                <div className="w-[1200px] m-10">
                    <div className="product_name_above_image" style={{ marginLeft: 0 }}>
                        {props.name}
                    </div>
                    <div className="min-h-[300px] flex">
                        <img src={props.image} className="rounded-lg w-[400px] h-[300px]" alt="Product Image" style={{objectFit:"contain"}} />
                        <div className="content_box min-h-[300px]">{props.content}</div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ProductDetailCard;
